import { ExIcon, IconSize } from '@boomi/exosphere';
import classNames from 'classnames';
import './securityIcon.css';

// Generic SecurityIcon component
interface SecurityIconProps {
    isPublic: boolean;
    size?: IconSize;
    className?: string | undefined;
    testId?: string;
    label: string;
}

export const SecurityIcon = ({
    isPublic: isItemPublic,
    size = IconSize.XS,
    className,
    testId,
    label,
}: SecurityIconProps) => {
    const icon = isItemPublic ? 'Unsecure' : 'Secure';
    const iconClassName = classNames(className, {
        'public-icon': isItemPublic,
        'secure-icon': !isItemPublic,
    });

    return (
        <span className="auth-icon">
            <ExIcon
                className={iconClassName}
                icon={icon}
                size={size}
                label={label}
                data-testid={testId}
            />
        </span>
    );
};

export default SecurityIcon;
